import Api from '../api/Api';
export var SET_TRANSFER_ACHIEVEMENTS = 'SET_TRANSFER_ACHIEVEMENTS';
export var SET_TRANSFER_BALANCE = 'SET_TRANSFER_BALANCE';
export var SET_GP_REWARD_BALANCE_TO_EXPIRE = 'SET_GP_REWARD_BALANCE_TO_EXPIRE';
export var SET_GP_REWARD_EXPIRATION_DATE = 'SET_GP_REWARD_EXPIRATION_DATE';
export var SET_GP_REWARD_EXPIRE_IN = 'SET_GP_REWARD_EXPIRE_IN';
export function setTransferAchievements(transfers) {
    return {
        type: SET_TRANSFER_ACHIEVEMENTS,
        payload: transfers
    };
}
export function setTransferBalance(balance) {
    return {
        type: SET_TRANSFER_BALANCE,
        payload: balance
    };
}
export function setGpRewardExpirationDate(gpRewardExpirationDate) {
    return {
        type: SET_GP_REWARD_EXPIRATION_DATE,
        payload: gpRewardExpirationDate
    };
}
export function setGpRewardBalanceToExpire(gpRewardBalanceToExpire) {
    return {
        type: SET_GP_REWARD_BALANCE_TO_EXPIRE,
        payload: gpRewardBalanceToExpire
    };
}
export function setGpRewardExpireIn(gpRewardExpireIn) {
    return {
        type: SET_GP_REWARD_EXPIRE_IN,
        payload: gpRewardExpireIn
    };
}
export function fetchTransferAchievements() {
    return function (dispatch) {
        return Api.User.getTransferAchievements().then(function (result) {
            dispatch(setTransferAchievements(result.next_steps));
            dispatch(setTransferBalance(result.gp_balance));
            dispatch(setGpRewardBalanceToExpire(result.gp_reward_balance_to_expire));
            dispatch(setGpRewardExpirationDate(result.gp_reward_expiration_date));
            dispatch(setGpRewardExpireIn(result.gp_reward_expire_in));
            return result;
        });
    };
}
